<template>

    <div class="row justify-content-center">

        <div class="col-lg-10">
            <div class="fieldset">
                <div class="switch-container d-flex justify-content-center align-items-center">
                    <span :class="['left-label', { active : model.type == 1 }]">
                        Аз съм възложител
                    </span>
                    <button type="button" 
                            :class="['btn btn-lg btn-toggle btn-switch', { active : model.type == 2 }]" 
                            @click="toggleType"
                            :aria-pressed="model.type == 2" autocomplete="off" >                        
                        <div class="handle"></div>                       
                    </button>
                    <span :class="['right-label', { active : model.type == 2 }]">
                        Аз съм изпълнител
                    </span>
                </div>

            </div>
        </div>

        <div class="col-lg-10">
            <div class="fieldset">
                <h3 class="fieldset-title">Лични данни</h3> 
                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <label for='name'>Име и фамилия:</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-user"></span>
                                    </div>
                                </div>                            
                                <input class='form-control input-lg' id='name' v-model='model.name'>
                            </div>
                        </div>

                    </div>
                    <!-- <div class="col-md-6 col-12">

                        <div class="form-group">
                            <label for='last_name'>Фамилия</label>
                            <input class='form-control' id='last_name' v-model='model.last_name'>
                        </div>

                    </div> -->
                    <div class="col-md-6 col-12">

                        <div class="form-group">
                            <label for='email'>E-mail адрес:</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-envelope"></span>
                                    </div>
                                </div>
                                <input class='form-control input-lg' id='email' v-model='model.email'>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6 col-12">

                        <div class="form-group">
                            <label for='phone'>Телефон:</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-phone"></span>
                                    </div>
                                </div>
                                <input class='form-control input-lg' id='phone' v-model='model.phone'>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6 col-12">
                        
                        <div class="form-group">
                            <label for='location'>Местоположение:</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-map-pin"></span>
                                    </div>
                                </div>
                                <input class='form-control input-lg' id='location' v-model='model.location'>
                            </div>                            
                        </div>

                    </div>

                    <div class="col-12">
                        
                        <div class="form-group">
                            <label for='mail_notifs'>Е-мейл известия</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-envelope"></span>
                                    </div>
                                </div>
                            
                                <select class='custom-select select-lg' id='mail_notifs' v-model='model.mail_notifs'>
                                    <option value='1'>Искам да получавам известия по е-мейл</option>
                                    <option value='0'>Не желая да получавам</option>
                                </select>
                            </div>
                        </div>

                    </div>

                    <div class="col-12">
                        <div class="form-group">
                            <label for='mail_notifs'>Кратко описание</label>
                            <textarea class='form-control' rows=5 
                                      v-model.trim='model.desc'></textarea>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group">
                            <label for='mail_notifs'>Линкове към вашата работа</label><br>
                            <small class="pl-2 d-block mb-3">
                                Ако искате, може да представите линкове към ваши проекти, с цел по-добра презентация пред клиентите.
                                Трябва да копирате линк към страницата, на която ще отведете клиента и да напишете неговото име.
                            </small>
                            <user-links></user-links>
                        </div>
                    </div>

                    <!-- <div class="col-12">

                        <div class="form-group">
                            <label for='status'>Тип</label>
                            <select class='custom-select select-lg' id='status' v-model='model.type'>
                                <option value='1'>Възложител</option>
                                <option value='2'>Изпълнител</option>
                            </select>
                        </div>

                    </div> -->

                    <div class='col-12 text-center'>
                        <form-validator ref='validator' :fields='validatorFields'></form-validator>

                        <button @click='save' class='btn btn-success btn-lg mt-2'>
                            <span class="icon icon-save"></span>
                            Запази
                        </button>

                    </div>

                </div>
            </div>
        </div>

        <div class="col-lg-10">
            <div class="fieldset">
                <h3 class="fieldset-title">Презентация</h3> 
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label v-if='model.presentation' for='mail_notifs'>Имате прикачена презентация</label>
                            <label v-else for='mail_notifs'>
                                Качете своя презентация
                                <small class="pl-2">( Разрешени формати: .pdf, .xls, .doc, .ppt )</small>
                            </label>

                            <div v-if='model.presentation' class="d-flex justify-content-between mt-3"> 
                                <a :href='model.presentation' v-if='model.presentation' download class="btn btn-secondary">
                                    <span class="icon icon-download"></span>
                                    Преглед на презентацията
                                </a>

                                <button @click='deletePresentation' class='btn btn-danger'>
                                    <span class="icon icon-x"></span>
                                    Изтрий
                                </button>
                            </div>

                            <div v-if='!model.presentation'>
                                <form action='/usr/uppf' method='POST' 
                                      enctype="multipart/form-data">

                                    <input type="file" :accept="allowedTypes.join(',')"
                                           name='file' id='upf'
                                           @change='fileSelect($event)'
                                           class='form-control upl-file-field'>

                                    <div v-if='canUpload' class="d-flex justify-content-center mt-3">
                                        <button class="btn btn-success btn-lg mt-2" type='submit'>
                                            <span class="icon icon-save"></span>
                                            Запази файла
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-10">
            <div class="fieldset">
                <h3 class="fieldset-title">Аз съм специалист в:</h3>
                <roles></roles>
            </div>
        </div>

        <div class="col-md-10">
            <div class="fieldset">
                <h3 class="fieldset-title">Смяна на парола</h3> 
                <pwd-change></pwd-change>
            </div>
        </div>
        <div class="col-md-10">
            <div class="fieldset text-center">
                <h3 class="fieldset-title">Изтриване на акаунт</h3> 
                <div class='alert alert-warning'>
                    Внимание веднъж изтрит, акаунта не може да бъде възтановен.
                </div>
                <button @click='deleteAccount()' class='btn btn-danger'>
                    Изтриване на акаунт
                </button>
            </div>
        </div>
        
    </div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            this.model = Object.assign( {}, this.user );
           
        },

        data() {
            return {
                isReady : false,     

                allowedTypes : [
                    '.pdf',
                    '.xls',
                    '.xlsx',
                    '.txt',
                    '.doc',
                    '.docx',
                    '.ppt',
                    '.pptx'
                ],

                maxFileSize : 6000000,
                forUpload : false,
                canUpload : false,


                model : false,

                //Validate User info
                validatorFields : [
                    { 
                        selector  : "#name",
                        minLength : 2,
                        customErr : 'Моля въведете име'
                    },
                    { 
                        selector  : "#location",
                        minLength : 2,
                        customErr : 'Моля въведете вашата локация'
                    },
                    // { 
                    //     selector  : "#last_name",
                    //     minLength : 2,
                    //     customErr : 'Моля въведете фамилия'
                    // },
                    { 
                        selector  : "#email",
                        minLength : 2,
                        regex     : this.emailRegex,
                        customErr : 'Моля въведете валиден мейл адрес'
                    }
                ]
            }
        },

        methods : {

            deletePresentation() {
                
                this.ajax.call('usr:dp', {}, (r) => {
                    if( r.status == 'success' ) {
                        this.model.presentation = null;
                        $.notify('Файлът беше премахнат','success');
                    }
                })

            },

            save() {

                var me = this;
                var payload = { fields : this.model };

                this.$refs.validator.validate({
                    resolve(){

                        me.isLoading = true;
                        var pl = Object.assign({}, me.model);
              
                        if( me.forUpload ) {
                            pl.file = me.forUpload;
                        }

                        me.ajax.call('usr:sp', pl , (r) => {
                            me.isLoading = false;

                            if( r.status == 'success' ) {

                                if( this.forUpload ) {
                                    this.forUpload = false;
                                    this.model.presentation = r.data;
                                }

                                me.setUser( Object.assign({}, me.model) );

                                me.notify('save-success');

                            }

                        })

                    }
                })

            },

            fileSelect( event ) {
                var me      = this;
                var input   = $(event.target);

                if ( event.target.files ) {

                    var file = event.target.files[0];

                    if(typeof file == 'undefined'){
                        input.val('');
                        this.canUpload = false;
                        return;
                    }
                    
                    var ext  = file.name.split('.').reverse()[0];

                    if( file.size > this.maxFileSize ) {
                        alert('Моля прикачете файл по малък от 5 MB.');
                        input.val('');

                        this.canUpload = false;
                        return false;
                    }

                    if( this.allowedTypes.indexOf( '.' + ext ) < 0 ) {
                        alert('Разширения от този тип не са приети :' + ext );
                        input.val('');
                        this.canUpload = false;
                        return false;
                    }

                    this.canUpload = true;

                    // var reader = new FileReader();

                    // //Loader start
                    // reader.onload = function(event) {
                    //     //Loader finish

                    // }

                    // reader.readAsDataURL(file);
                }
            },

            deleteAccount() {
                var msg = "Сигурни ли сте, че искате да премахнете акаунта си във Видеа?";

                if( !confirm( msg ) ) {
                    return;
                }

                this.ajax.call('acc:rm', {}, (r) => {

                    if( r.status == 'success' ) {
                        $.notify("Вашият акаунт беше изтрит успешно","success");

                        setTimeout( () => {
                            location.href = '/';
                        },1000)
                    }

                })
            },

            toggleType() {

                if( this.model.type == 1 ) {
                    this.model.type = 2;
                }
                else {
                    this.model.type = 1;
                }

                console.log( this.model.type );

            }
        },

        components : { 
            'pwd-change'        : require("./PasswordChange.vue").default,
            'roles'             : require("./Roles.vue").default,
            'user-links'        : require("./UserLinks.vue").default
        }

    }
</script>
